import type {CustomerProfileActivityContext} from "~/components/entityProfile/customerProfileDataSource/types";
import {ProfileCustomerActivityTimeline} from "~/components/entityProfile/activity/profileCustomerActivityTimeline";
import type {ProfileTabRenderProps} from "~/components/entityProfile/types";

export function ProfileCustomerActivityTabContent({
    tabRenderProps,
    activity,
}: {
    tabRenderProps: ProfileTabRenderProps;
    activity: CustomerProfileActivityContext;
}) {
    if (tabRenderProps.kind !== "customer") {
        return null;
    }

    return (
        <div className="flex h-full min-h-0 flex-col overflow-hidden">
            <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-ds-space-200 pb-ds-space-200 py-ds-space-150">
                <ProfileCustomerActivityTimeline
                    groups={activity.groups}
                    isLoading={activity.isLoading}
                    isError={activity.isError}
                />
            </div>
        </div>
    );
}
